import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgStudents = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 18 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M2 0H16C17.0938 0 18 0.90625 18 2V12C18 13.125 17.0938 14 16 14H2C0.875 14 0 13.125 0 12V2C0 0.90625 0.875 0 2 0ZM4.5 8C3.09375 8 2 9.125 2 10.5C2 10.7813 2.21875 11 2.5 11H8.5C8.75 11 9 10.7813 9 10.5C9 9.125 7.875 8 6.5 8H4.5ZM3.5 5C3.5 5.71875 3.875 6.375 4.5 6.75C5.09375 7.09375 5.875 7.09375 6.5 6.75C7.09375 6.375 7.5 5.71875 7.5 5C7.5 4.3125 7.09375 3.65625 6.5 3.28125C5.875 2.9375 5.09375 2.9375 4.5 3.28125C3.875 3.65625 3.5 4.3125 3.5 5ZM11.5 4C11.2188 4 11 4.25 11 4.5C11 4.78125 11.2188 5 11.5 5H15.5C15.75 5 16 4.78125 16 4.5C16 4.25 15.75 4 15.5 4H11.5ZM11.5 6C11.2188 6 11 6.25 11 6.5C11 6.78125 11.2188 7 11.5 7H15.5C15.75 7 16 6.78125 16 6.5C16 6.25 15.75 6 15.5 6H11.5ZM11.5 8C11.2188 8 11 8.25 11 8.5C11 8.78125 11.2188 9 11.5 9H15.5C15.75 9 16 8.78125 16 8.5C16 8.25 15.75 8 15.5 8H11.5Z",
		fill: "currentColor"
	})
});
export default SvgStudents;
